import React from "react";
import { Heading, IconButton, Dialog, DialogContent, DialogClose, DialogTitle, DialogDescription } from "@/shared/components/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { DialogProps } from "@/shared/types/Modals";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { faWarning } from "@fortawesome/pro-regular-svg-icons";

export const PreExistingConditionsModal: React.FC<DialogProps> = ({ open, onClose }) => {
    function handleOverlayClick() {
        if (onClose) {
            onClose(false);
        }
    }

    function handleContentClick(event: React.MouseEvent) {
        event.stopPropagation();
    }

    return (
        <Dialog open={open}>
            <DialogContent onEscapeKeyDown={handleOverlayClick} onClick={handleContentClick} onOverlayClick={handleOverlayClick}>
                <VisuallyHidden asChild>
                    <DialogTitle>What are pre-existing conditions?</DialogTitle>
                </VisuallyHidden>
                <VisuallyHidden asChild>
                    <DialogDescription>Pre-existing conditions</DialogDescription>
                </VisuallyHidden>
                <DialogClose asChild>
                    <IconButton onClick={() => onClose && onClose(false)}>
                        <FontAwesomeIcon icon={faXmark} className="size-5 text-content-primary" />
                    </IconButton>
                </DialogClose>
                <div className="flex w-full flex-col gap-2 text-base leading-6 text-content-secondary">
                    <Heading level="h3" className="text-lg font-semibold text-content-primary">
                        Pre-existing Conditions
                    </Heading>
                    <p>Pre-existing conditions are conditions that occur before coverage begins or during a waiting period, most pet insurance providers don’t cover them.</p>
                    <div className="flex flex-row items-start gap-2 rounded-r-md bg-background-warning px-3 py-2 text-content-warning">
                        <FontAwesomeIcon className="size-4 " icon={faWarning} />
                        <p className="text-sm font-bold leading-5">The sooner you sign up, the better the chances of future conditions being covered.</p>
                    </div>
                    <p>
                        A condition will no longer be considered pre-existing if it has been cured and free of symptoms and treatment for 180 days, with the exception of knee and
                        ligament conditions. If a knee or ligament condition occurs before the coverage effective date or during a waiting period, any future ones won’t be covered.
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    );
};
